import getNextFocusEle from './getNextFocusElement';

export default class DropdownWatcher {
    constructor(containerEl, triggerEle, closeFunc) {
        this.containerEl = containerEl;
        this.closeFunc = closeFunc;
        this.isFoundation = containerEl.data('dropdown-content') !== undefined;

        if (this.isFoundation) {
            const dropDownContainerId = this.containerEl.attr('id');
            this.triggerEle = $(`[data-dropdown="${dropDownContainerId}"]`);
        } else {
            this.triggerEle = triggerEle;
        }

        this.bindEvents();
    }

    bindEvents() {
        const watcher = this;
        this.containerEl.on('keydown', function (e) {
            const dropdownEl = $(this);
            const isOpen = dropdownEl.is(':visible');
            if (isOpen) {
                const activeElem = $(document.activeElement);
                const firstFocusableEl = dropdownEl
                    .find(':focusable:visible')
                    .first();
                const lastFocusableEl = dropdownEl
                    .find(':focusable:visible')
                    .last();

                if (e.key === 'Escape') {
                    watcher.setFocus();
                    watcher.close();
                }

                const isTabbingOut =
                    e.key === 'Tab' &&
                    (((activeElem.is(firstFocusableEl) ||
                        activeElem.is(dropdownEl)) &&
                        e.shiftKey) ||
                        (activeElem.is(lastFocusableEl) && !e.shiftKey));

                const isTabbingForward = e.key === 'Tab' && !e.shiftKey;

                if (isTabbingOut) {
                    e.preventDefault();
                    watcher.setFocus(isTabbingForward);
                    watcher.close();
                }
            }
        });
    }

    setFocus(isForward = false) {
        if (isForward) {
            const nextFocusEle = getNextFocusEle(
                this.triggerEle,
                this.containerEl.find('*')
            );
            nextFocusEle.focus();
        } else {
            this.triggerEle.focus();
        }
    }

    close() {
        if (typeof this.closeFunc !== 'undefined') {
            this.closeFunc();
        } else if (this.isFoundation) {
            window.Foundation.libs.dropdown.close(this.containerEl);
        } else {
            this.containerEl.hide();
        }
    }
}

export { DropdownWatcher };
